import React from 'react';
import AIBuilderSection from '@/components/home/AIBuilderSection';
import FAQSection from '@/components/home/FAQSection';
import SEOHead from '@/components/SEOHead';

const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'BuildersLab',
  url: 'https://builderslab.net',
  logo: 'https://builderslab.net/images/builderslab-logo.png',
  description: 'AI-powered website builder that creates professional websites in seconds.',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'hello@builderslab.net',
    contactType: 'customer support',
  },
};

export default function Home() {
  return (
    <div className="bg-zinc-950">
      <SEOHead
        title="Vibe Coding Platform for Apps, Website and Games"
        description="BuildersLab uses AI to generate professional websites and apps instantly. Describe your idea and our AI builds it in seconds. No coding required. Start free today."
        ogUrl="https://builderslab.net"
        jsonLd={ORG_SCHEMA}
      />
      {/* The BuildersLab Business pitch (components/home/BusinessSection) sat
          between these two. Taken off the home page on request; the component
          is kept, so putting it back is one line. */}
      <AIBuilderSection />
      <FAQSection />
      {/* The "Have a big idea?" custom-build enquiry that closed this page has
          its own page now, /CustomBuilds (Resources menu and footer). */}
    </div>
  );
}